var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7207 23.5999V9.71516C4.7207 6.43121 7.38531 3.7666 10.6693 3.7666H14.0684",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5544 7.30957V19.2067C24.5544 21.6264 22.5812 23.5997 20.1614 23.5997H10.1367",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5524 10.8818V18.5732H14.5586V10.8818H15.5524Z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0483 9.68639C15.5733 9.68639 15.9989 9.26078 15.9989 8.73577C15.9989 8.21076 15.5733 7.78516 15.0483 7.78516C14.5233 7.78516 14.0977 8.21076 14.0977 8.73577C14.0977 9.26078 14.5233 9.68639 15.0483 9.68639Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/helpCenter.8206dfcf220bcf6d2c19d40a0c22a7ab.svg";
export { ForwardRef as ReactComponent };